module.exports = __webpack_public_path__ + "static/media/ic-3.2e0c149e.svg";